/* ---------------------------- processing (p5.js) --------------------------- */
// note: use p5.js in react components will decouple from the original life cycle function control
// use setup, draw etc... instead
import Sketch from 'react-p5'
/* ---------------------------------- React --------------------------------- */
import React from 'react'
/* --------------------------- loading QR code -------------------------- */
import QRCode from 'qrcode'

class App extends React.Component {
	/* -------------------------- For weather paintings ------------------------- */
	weather_images = []
	weather_names = []
	weather_num = []
	weather_start = []
	weather_end = []
	name_weather = 0
	weather_load_finish = false
	weather_img_displaying = null
	/* ------------------------- For portrait paintings ------------------------- */
	portrait_images = []
	async_portrait_images = []
	imgPaths = []
	portrait_end_index = undefined
	portrait_load_finish = false
	forward = 0
	/* ----------------------------------- sec ---------------------------------- */
	timer_e = 0
	time_e = 0.1
	timer_q = 0
	time_q = 0.8
	timer_b = 0
	time_b = 0.65
	/* ------------------------------- For display ------------------------------ */
	caselabel = 'i'
	img_displaying = undefined
	pre_img_displaying = null
	/* -------------------------- Guess game main page -------------------------- */
	FontPlay = undefined
	margin_B = undefined
	color_play = 1
	/* --------------------------------- QRcode --------------------------------- */
	/* ------------------------------ QR code image ----------------------------- */
	QRimg = undefined
	/* -------------------------- QRcode region height -------------------------- */
	QRheight = 0
	QRmargin = 0
	/* ---------------------------- this.percentage string --------------------------- */
	percentage = '0'
	truly_End_flag = 0
	/* ---------------------------------- Setup --------------------------------- */
	setup = async (p5, canvasParentRef) => {
		p5.frameRate(1);
		p5.createCanvas(window.innerWidth, window.innerHeight, p5.P2D).parent(canvasParentRef);
		p5.noCursor();
		this.FontPlay = p5.textFont('SansSerif', 60);

		// Load weather paintings
		await this.loadWeatherImageThread(p5);
		this.portrait_load_finish = true;

		// Set QR code
		this.QRheight = p5.height / 6;
		this.QRmargin = 0.05 * this.QRheight;
		this.generateQrcode(p5);

		this.margin_B = p5.int(p5.width / 8);
	}
	/* ---------------------------------- Draw ---------------------------------- */
	draw = async (p5) => {
		// console.log(`[frontend] ${this.caselabel}`)
		// receive command from server
		if (this.weather_load_finish && this.portrait_load_finish && window.recv.length !== 0) {
			let data = p5.splitTokens(window.recv[window.recv.length - 1], ',;');
			console.log(`[cmd] Message from DAI : cmd=${data[0]}, value=${data[1]}`);

			switch (data[0]) { //WINDOW CMD
				case 'w': // w: update weather images
					this.name_weather = p5.int(data[1]);
					console.log(`[cmd] set weather = ${this.name_weather}`);
					break;
				case 'l': // l: load game status
					console.log(`[cmd] get portrait path`)
					this.imgPaths = data.slice(1);
					this.portrait_end_index = this.imgPaths.length - 1; // TODO: why -1
					this.forward = -1;
					this.caselabel = data[0];
					break;
				case 'f': // f: forward portrait image
					this.forward = this.forward + 1;
					console.log(`[cmd] update forward=${this.forward}`);
					break;
				case 'q': // q: leaved game, return weather mode
					console.log(`[cmd] leave game`);
					this.pre_img_displaying = null;
					this.caselabel = data[0];
					break;
				case 's': // s: select game mode
				case 'g': // g: select group
				case 'm': // m: select member
				case 'e': // e: end game
					this.caselabel = data[0];
					break;
			}
			// clear receive command
			this.clearRecvHandler();
		}

		// TODO: check this switch
		switch (this.caselabel) {
			/* -------------------------------- frame init -------------------------------- */
			// ************** case I: Frame initialization ****************************
			case 'i':
				p5.background(0)
				p5.noStroke()
				p5.fill(p5.map((p5.frameCount % 70) + 1, 1, 69, 180, 10))
				p5.ellipse(
					p5.width / 2,
					p5.height / 2,
					((p5.frameCount % 70) + 1) * 10,
					((p5.frameCount % 70) + 1) * 10
				)
				p5.textAlign(p5.CENTER, p5.CENTER)
				p5.textSize(50)
				p5.textFont('Monaco')
				p5.fill(255)
				p5.text('Loading data ... ', p5.width / 2, p5.height / 2)
				if (this.weather_load_finish && this.portrait_load_finish) {
					p5.text('');
					this.caselabel = 'w'
				}
				this.clearRecvHandler()
				break
			// ************** case W: Display Weather *****************************
			case 'w':
				try {
					let resizeWidth
					let resizeHeight
					let prepareImage = this.weather_images[this.weather_start[this.name_weather]]
					if (prepareImage.width >= prepareImage.height) {
						resizeWidth = p5.width
						resizeHeight = prepareImage.height * (p5.width / prepareImage.width)
						if (resizeHeight >= p5.height) {
							resizeWidth = resizeWidth * (p5.height / resizeHeight)
							resizeHeight = p5.height
						}
					} else {
						resizeHeight = p5.height
						resizeWidth = prepareImage.width * (p5.height / prepareImage.height)
						if (resizeWidth >= p5.width) {
							resizeHeight = resizeHeight * (p5.width / resizeWidth)
							resizeWidth = p5.width
						}
					}
					prepareImage.resize(resizeWidth, resizeHeight)
					p5.image(prepareImage, (p5.width - resizeWidth) / 2, (p5.height - resizeHeight) / 2)
					// draw QR code
					if (this.QRimg) {
						p5.image(
							this.QRimg,
							p5.width - (p5.width - resizeWidth) / 2 - this.QRimg.width - this.QRmargin,
							p5.height - (p5.height - resizeHeight) / 2 - this.QRimg.height - this.QRmargin
						)
					}
				} catch (exception) {
					console.log(`[frontend] case W failed: ${exception}`);
				}
				this.clearRecvHandler()
				break
			// ************** case B: Mode(Start) Page ****************************
			case 's':
				p5.frameRate(60)
				p5.background(0, 0, 0)
				p5.fill(246, 224, 183)
				p5.rect(
					this.margin_B,
					this.margin_B,
					p5.width - 2 * this.margin_B,
					p5.height - 2 * this.margin_B,
					30,
					30,
					30,
					30
				)
				if (this.timer_b < this.time_b) {
					this.color_play = 0
				} else if (this.timer_b >= this.time_b && this.timer_b < 2 * this.time_b) {
					this.color_play = 1
				} else {
					this.timer_b = 0
				}
				this.timer_b += 1 / p5._frameRate

				if (this.color_play === 0) {
					p5.fill(96, 192, 220)
					this.color_play = 1
				} else {
					p5.fill(46, 154, 186)
					this.color_play = 0
				}
				p5.noStroke()
				p5.rect(
					p5.width / 3 - p5.width / 6,
					p5.height / 2 - p5.width / 16,
					(p5.width * 4) / 6,
					p5.width / 8,
					30,
					30,
					30,
					30
				)
				p5.fill(255, 255, 255)
				p5.textAlign(p5.CENTER, p5.CENTER)
				p5.textFont(this.FontPlay)
				p5.textSize(45)
				p5.text('選擇模式', p5.width / 2, p5.height / 2)
				this.clearRecvHandler()
				break

			// ************** case G: Group Page ****************************
			case 'g':
				p5.background(0, 0, 0)
				p5.fill(246, 224, 183)
				p5.rect(
					this.margin_B,
					this.margin_B,
					p5.width - 2 * this.margin_B,
					p5.height - 2 * this.margin_B,
					30,
					30,
					30,
					30
				)

				if (this.timer_b < this.time_b) {
					this.color_play = 0
				} else if (this.timer_b >= this.time_b && this.timer_b < 2 * this.time_b) {
					this.color_play = 1
				} else {
					this.timer_b = 0
				}
				this.timer_b += 1 / p5._frameRate

				if (this.color_play === 0) {
					p5.fill(90, 98, 104)
					this.color_play = 1
				} else {
					p5.fill(63, 71, 76)
					this.color_play = 0
				}
				p5.noStroke()
				p5.rect(
					p5.width / 3 - p5.width / 6,
					p5.height / 2 - p5.width / 16,
					(p5.width * 4) / 6,
					p5.width / 8,
					30,
					30,
					30,
					30
				)
				p5.fill(255, 255, 255)
				p5.textAlign(p5.CENTER, p5.CENTER)
				p5.textFont(this.FontPlay)
				p5.textSize(45)
				p5.text('選擇群組', p5.width / 2, p5.height / 2)
				this.clearRecvHandler()
				break

			// ************** case M: Member Page ****************************
			case 'm':
				p5.background(0, 0, 0)
				p5.fill(246, 224, 183)
				p5.rect(
					this.margin_B,
					this.margin_B,
					p5.width - 2 * this.margin_B,
					p5.height - 2 * this.margin_B,
					30,
					30,
					30,
					30
				)

				if (this.timer_b < this.time_b) {
					this.color_play = 0
				} else if (this.timer_b >= this.time_b && this.timer_b < 2 * this.time_b) {
					this.color_play = 1
				} else {
					this.timer_b = 0
				}
				this.timer_b += 1 / p5._frameRate

				if (this.color_play === 0) {
					p5.fill(220, 53, 69)
					this.color_play = 1
				} else {
					p5.fill(247, 96, 109)
					this.color_play = 0
				}
				p5.noStroke()
				p5.rect(
					p5.width / 3 - p5.width / 6,
					p5.height / 2 - p5.width / 16,
					(p5.width * 4) / 6,
					p5.width / 8,
					30,
					30,
					30,
					30
				)
				p5.fill(255, 255, 255)
				p5.textAlign(p5.CENTER, p5.CENTER)
				p5.textFont(this.FontPlay)
				p5.textSize(40)
				p5.text('選擇圖集', p5.width / 2, p5.height / 2)
				this.clearRecvHandler()
				break

			// ************** case L: Loading portrait ****************************
			case 'l':
				if (this.forward === -1) {
					this.portrait_load_finish = false
					this.percentage = '0'
					await this.loadPortraitImagesThread(p5, this.imgPaths)
					this.forward = 0
				}

				p5.background(0)
				p5.noStroke()
				p5.fill(p5.map((p5.frameCount % 70) + 1, 1, 69, 180, 10))
				p5.ellipse(
					p5.width / 2,
					p5.height / 2,
					((p5.frameCount % 70) + 1) * 10,
					((p5.frameCount % 70) + 1) * 10
				)
				p5.textAlign(p5.CENTER, p5.CENTER)
				p5.textSize(50)
				p5.textFont(this.FontPlay)
				p5.fill(255)
				p5.text('Loading data ... ' + this.percentage + '%', p5.width / 2, p5.height / 2)
				if (this.portrait_load_finish) this.caselabel = 'p'
				this.clearRecvHandler()
				break

			// ************** case P: Display portrait ****************************
			case 'p':
				try {
					let resizeWidth
					if (this.portrait_load_finish) {
						p5.background(0)
						if (this.forward > this.portrait_end_index) {
							if (this.pre_img_displaying !== null) {
								resizeWidth =
									(this.pre_img_displaying.width * p5.height) / this.pre_img_displaying.height
								this.pre_img_displaying.resize(resizeWidth, p5.height)
								p5.image(this.pre_img_displaying, (p5.width - resizeWidth) / 2, 0)
							}
							this.clearRecvHandler()
							break
						}

						if (this.portrait_images.length > 0) {
							this.truly_End_flag = 0

							this.img_displaying = this.portrait_images[this.forward]
							if (this.img_displaying !== null) {
								resizeWidth = (this.img_displaying.width * p5.height) / this.img_displaying.height
								this.img_displaying.resize(resizeWidth, p5.height)
								p5.image(this.img_displaying, (p5.width - resizeWidth) / 2, 0)
								this.pre_img_displaying = this.img_displaying
							} else {
								if (this.pre_img_displaying !== null) {
									resizeWidth =
										(this.pre_img_displaying.width * p5.height) / this.pre_img_displaying.height
									this.pre_img_displaying.resize(resizeWidth, p5.height)
									p5.image(this.pre_img_displaying, (p5.width - resizeWidth) / 2, 0)
								}
								this.forward += 1
							}
						}
					}
				} catch (exception) {
					console.log(`[frontend] ${exception}`)
					console.log(`[frontend] case P failed`)
					this.clearRecvHandler()
				}
				break

			// ************** case E: End portrait ****************************
			case 'e':
				console.log("case E")
				if (this.forward < this.portrait_end_index) {
					if (this.timer_e >= this.time_e) {
						this.forward += 1
						this.timer_e = 0
					} else {
						// this.timer_e += 1 / p5._frameRate
						this.timer_e += 0.25 / p5._frameRate
						console.log("add time:", this.timer_e)
					}
				} else {
					this.caselabel = 'p'
					this.timer_e = 0
				}
				try {
					let resizeWidth
					if (this.portrait_images.length > 0 && this.forward <= this.portrait_end_index) {
						this.img_displaying = this.portrait_images[this.forward]
						if (this.img_displaying !== null) {
							resizeWidth = (this.img_displaying.width * p5.height) / this.img_displaying.height
							this.img_displaying.resize(resizeWidth, p5.height)
							p5.image(this.img_displaying, (p5.width - resizeWidth) / 2, 0)
							this.pre_img_displaying = this.img_displaying
						} else if (this.pre_img_displaying !== null) {
							resizeWidth = (this.pre_img_displaying.width * p5.height) / this.pre_img_displaying.height
							this.pre_img_displaying.resize(resizeWidth, p5.height)
							p5.image(this.pre_img_displaying, (p5.width - resizeWidth) / 2, 0)
						}
					}
					if (this.forward >= this.portrait_end_index && this.truly_End_flag === 0) {
						this.truly_End_flag = 1
					}
					if (this.truly_End_flag === 1) {
						this.truly_End_flag = 2
						this.forward += 1
						this.sendHandler('DisplayFinish:true')
						this.clearRecvHandler()
						console.log(`[frontend] display finish`)
						console.log(`[frontend] E2 `, this.forward, this.portrait_end_index)
					}
				} catch (exception) {
					console.log(`[frontend] case E failed: `, exception)
					this.clearRecvHandler()
				}
				break

			// ************** case Q: Quit Page **************************
			case 'q':
				// release cache
				this.portrait_images = []

				// reset background
				p5.background(0)

				// show leave game message
				p5.textAlign(p5.CENTER, p5.CENTER)
				p5.textSize(60)
				p5.textFont(this.FontPlay)
				p5.fill(180)
				p5.text('See you !', p5.width / 2, p5.height / 2)
				// p5.tint portrait
				p5.tint(255, p5.map(this.timer_q, 0, this.time_q, 255, 0))
				p5.noTint()
				this.timer_q += 1 / p5._frameRate
				if (this.timer_q >= this.time_q) {
					this.timer_q = 0
					this.caselabel = 'w'
				}
				this.clearRecvHandler()
				break

			default:
				break
		}
	}
	/* ----- load QR code ----- */
	generateQrcode = (p5) => {
		console.log('[img-qrcode] Generate QRcode');
		let QRInterval = setInterval(() => {
			if (window.configs.p_id !== undefined && window.configs.odo_id !== undefined) {
				QRCode
					.toDataURL(`${window.player_url}?p_id=${window.configs.p_id}&do_id=${window.configs.odo_id}`)
					.then((url) => {
						try {
							this.QRimg = p5.loadImage(url);
							this.QRimg.resize(this.QRheight - 2 * this.QRmargin, this.QRheight - 2 * this.QRmargin);
							clearInterval(QRInterval);
							console.log('[img-qrcode] Generate QRcode complete');
							console.log(`${window.player_url}?p_id=${window.configs.p_id}&do_id=${window.configs.odo_id}`);
						} catch (exception) {
							console.error(`[img-qrcode] QR code error: ${exception}`);
						}
					})
			}
		}, 200);
	}
	/* ----- Thread for loading all weather images ----- */
	loadWeatherImageThread = (p5) => {
		return new Promise((resolve) => {
			console.log(`[img-weather] loading: ${window.weather_db_path}`);
			Promise
				.all(window.weather_db_path.map((weather_name) => import(`${weather_name}.jpg`)))
				.then((importResults) => {
					// loadWeatherImages
					// Load all weather paintings, save all in images buffer
					importResults.forEach((x, i) => {
						this.weather_num[i - 1] = 1
						this.weather_start[i - 1] = i - 1
						this.weather_end[i - 1] = i - 1
						x = p5.loadImage(x.default)
						this.weather_images[i] = x
					})
					this.weather_load_finish = true
					console.log(`[img-weather] number of total images: `, this.weather_images.length)
					resolve()
			})
		})
	}
	/* ----- Thread for loading portrait images ----- */
	loadPortraitImagesThread = async (p5, img_paths) => {
		this.portrait_load_finish = false;
		// remove cache
		this.portrait_images = [];
		// load images
		await this.loadPortraitImages(p5, img_paths);
		this.portrait_load_finish = true
		this.sendHandler('Loading:finish')
	}
	/* ----- Load single portrait paintings ----- */
	loadPortraitImages = (p5, img_paths) => {
		return new Promise((resolve) => {
			let timer = p5.millis();
			let finish_count = -1;
			let process_flag = [];

			img_paths.forEach((img, idx) => {
				// TOFIX: check if the path is correct
				console.log(window.manage_url + img);
				this.portrait_images[idx] = p5.loadImage(window.manage_url + img);
				process_flag[idx] = false;
			});

			while (finish_count !== this.portrait_end_index) {
				img_paths.forEach((img, idx) => {
					if (this.portrait_images[idx].width > 0 && process_flag[idx] === false) {
						// resize image
						let img = this.portrait_images[idx];
						img.resize(p5.int(p5.width * 0.8), p5.int(p5.height * 0.8));
						process_flag[idx] = true;
						finish_count += 1;

						// loading percentage
						this.percentage = p5.str(p5.round(100 * (finish_count + 1) / img_paths.length));
						this.sendHandler('Loading:' + this.percentage);
						console.log(`[img] load ${img} done, percentage ${this.percentage}%`);

						// finished, resolve the promise
						if (finish_count === this.portrait_end_index) {
							console.log(`[img] portrait loading done`);
							resolve();
						}
					}
				})
				if (p5.millis() - timer > 20000) {
					break
				}
			}
		})
	}
	/* ----- web socket client send message handler ----- */
	sendHandler = (message) => {
		window.MsgHandler('DAI', message);
	}
	/* ----- web socket client clear recv message handler ----- */
	clearRecvHandler = () => {
		window.recv = [];
	}
	/* ----- react component render ----- */
	render() {
		return (
			<div className="App">
				<Sketch
					setup={this.setup}
					draw={this.draw}
					style={{
						height: '100vh',
						width: '100vw',
						display: 'flex',
						justifyContent: 'center',
						backgroundColor: 'black',
					}}
				/>
			</div>
		)
	}
}
export default App
